import Image from 'next/image'
import React from 'react'
import LoginButton from '@/components/authorization/LoginButton'
import LogoutButton from '@/components/authorization/LogoutButton'
import { LanguageSwitcher } from '@/components/localisation/LanguageSwitcher'
import { useUserStore } from '@/stores/user-store'
import { cn } from '@/utils/tailwind/utils'

const UserDisplay = ({ className = '' }) => {
  const user = useUserStore((state) => state.user)

  return (
    <>
      {user ? (
        <div className={cn('flex items-center text-nriched-yellow', className)}>
          <div>
            <div>{user.name}</div>
            {/* <p>{user.email}</p> */}

            <div className="flex items-center justify-between space-x-2 md:space-x-4">
              <LanguageSwitcher />
              <LogoutButton className="mr-2 h-8 w-8 text-nriched-yellow" />
            </div>
          </div>
          {user.picture && (
            <Image className="ml-2 rounded-full" src={user.picture} width={50} height={50} alt={user.name || ''} />
          )}
        </div>
      ) : (
        <div className={cn('flex items-center space-x-2 md:space-x-4', className)}>
          <LanguageSwitcher className="text-nriched-yellow" />
          <LoginButton />
        </div>
      )}
    </>
  )
}

export default UserDisplay
